module.exports = __webpack_public_path__ + "static/img/xiugaiyinliang2.6bf5595.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/xiugaiyinliang2.png
// module id = kzzY
// module chunks = 24